import { PLUGIN_METABOT_DASHBOARDS } from "metabase/metabot";

import { DashboardUpdatedMessage } from "./DashboardUpdatedMessage";
import { handleDashboardUpdated } from "./actions";

/**
 * Lets Metabot build and change dashboards: a dashboard it saves is opened or reloaded, and the chat shows what
 * changed, with Undo.
 */
export function initializeMetabotDashboardsPlugin() {
  PLUGIN_METABOT_DASHBOARDS.handleDashboardUpdated = handleDashboardUpdated;
  PLUGIN_METABOT_DASHBOARDS.DashboardUpdatedMessage = DashboardUpdatedMessage;
}
